<template>
  <div v-loading="listLoading" element-loading-text="拼命加载中...">
    <div class="filter" style="margin-top: -30px">
      <el-tabs type="border-card" class="card-tab">
        <el-tab-pane label="灵工签约记录">
          <el-form
            :model="param"
            :inline="true"
            label-width="125px"
            class="formInline"
            size="mini"
          >
            <div class="slide-wrap" ref="slideWrap1">
              <el-form-item label="姓名">
                <el-input
                  v-model="param.name"
                  placeholder="请输入..."
                  :maxlength="80"
                ></el-input>
              </el-form-item>
              <el-form-item label="促销员ID">
                <el-input
                  v-model="param.empPk"
                  placeholder="请输入..."
                  :maxlength="80"
                ></el-input>
              </el-form-item>
              <el-form-item label="身份证号">
                <el-input
                  v-model="param.idcard"
                  placeholder="请输入..."
                  :maxlength="80"
                ></el-input>
              </el-form-item>
              <el-form-item label="签约平台">
                <el-select
                  clearable
                  v-model="param.serviceSupplier"
                  filterable
                  placeholder="请选择..."
                >
                  <el-option label="全部" :value="null"></el-option>
                  <el-option
                    :label="item"
                    :value="item"
                    v-for="item in serviceSuppliers"
                    :key="item"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="客户">
                <el-select
                  clearable
                  v-model="param.customer"
                  filterable
                  placeholder="请选择..."
                >
                  <el-option label="全部" :value="null"></el-option>
                  <el-option
                    :label="item"
                    :value="item"
                    v-for="(item, index) in allClientId"
                    :key="index"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="供应商">
                <el-select
                  v-model="param.merchantNO"
                  filterable
                  placeholder="请选择..."
                >
                  <el-option label="全部" :value="null"></el-option>
                  <el-option
                    v-for="item in suppliersAll"
                    :label="item.name"
                    :key="item.code"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="公司名称" prop="companyCode">
                <el-select v-model="param.companyCode" filterable placeholder="请选择公司名称...">
                  <el-option label="全部" :value="null"></el-option>
                  <el-option v-for="item in companiesAll" :label="item.name" :key="item.code"
                         :value="item.code"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="签约时间">
                <el-date-picker
                  value-format="yyyy-MM-dd 00:00:00"
                  v-model="param.startTime"
                  type="date"
                  placeholder="请选择签约开始时间"
                ></el-date-picker>
                -
                <el-date-picker
                  value-format="yyyy-MM-dd 23:59:59"
                  v-model="param.endTime"
                  type="date"
                  placeholder="请选择签约结束时间"
                ></el-date-picker>
              </el-form-item>
            </div>
            <hr style="margin-bottom: 9px" />
            <div class="slide-btns clearfix">
              <el-form-item>
                <el-button type="text" class="reset-btn" @click="resetForm()"
                  >清空</el-button
                >
                <el-button class="search-btn" @click="submitForm()"
                  >筛选</el-button
                >
                <el-button class="search-btn" @click="exportResult()"
                  >导出</el-button
                >
              </el-form-item>
              <div class="floatr">
                <el-form-item>
                  <!-- v-if="showSlideBtn()" -->
                  <el-button
                    type="text"
                    class="slide-btn"
                    @click="toggleSlide('slideWrap1', $event)"
                    >收起筛选项</el-button
                  >
                </el-form-item>
              </div>
            </div>
          </el-form>
        </el-tab-pane>
      </el-tabs>
      <div class="tableBody">
        <div class="title">筛选结果</div>
        <el-table
          class="limitManagerTable table-expand"
          style="width: 100%"
          :data="tableData"
          size="small"
          border
          header-row-class-name="table-header"
        >
          <el-table-column
            fixed="left"
            width="50"
            type="index"
            label="#"
            align="center"
          ></el-table-column>
          <el-table-column
            width="110"
            prop="name"
            label="姓名"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="empPk"
            label="促销员ID"
            minWidth="110"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="idcard"
            label="身份证号"
            align="center"
            :formatter="formatIdCard"
            width="150"
          ></el-table-column>
          <el-table-column
            prop="companyName"
            label="所属公司"
            minWidth="210"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="owenrName"
            label="服务商"
            minWidth="210"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="customer"
            label="客户"
            minWidth="260"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="serviceSupplier"
            label="签约平台"
            minWidth="80"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="merchantName"
            label="落地方"
            minWidth="220"
            align="center"
          ></el-table-column>
          <el-table-column
            width="140"
            prop="signedTime"
            label="签约时间"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ computedTime(scope.row.signedTime) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            width="120"
            prop="startTime"
            label="合同开始日期"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ computedDate(scope.row.startTime) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            width="120"
            prop="endTime"
            label="合同结束日期"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ computedDate(scope.row.endTime) }}</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination table-pagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page.pageNo"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="page.pageSize"
          layout="slot,sizes, total,  prev, pager, next, jumper"
          :total="page.total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
  
<script>
import utils from "../../common/js/util.js";
import moment from "moment";
export default {
  data() {
    return {
      //筛选项参数
      param: {},
      param2: {}, //点击筛选之后param才赋值给param2
      //表单翻页
      page: {
        pageNo: 1,
        pageSize: 10,
        total: null,
      },
      allClientId: [],
      suppliersAll: [],
      companiesAll: [],
      serviceSuppliers: [],
      tableData: [], //表单信息
      listLoading: false,
    };
  },
  mounted() {
    this.getData();
    this.getAllClientId();
    this.getServiceSuppliers();
    this.searchSuppliersAll();
    this.searchCompaniesAll();
  },
  methods: {
    //获取数据
    getData() {
      this.listLoading = true;
      let params = {
        ...this.param2,
        pageSize: this.page.pageSize,
        pageNum: this.page.pageNo,
      };
      //获取表单数据
      this.$http({
        method: "POST",
        // headers: { "content-type": "application/json" },
        url: "/rest/salesman/signingRecordList",
        data: params,
      })
        .then((res) => {
          this.tableData = res.data.data.list;
          this.page.total = res.data.data.totalCount;
          this.listLoading = false;
        })
        .catch((err) => {
          this.listLoading = false;
          this.myNotify(this, "error", err.response, "查询失败，请稍后重试");
        });
    },
    formatIdCard(row, column, cellValue) {
      if (
        sessionStorage.getItem("user") == "admin1" ||
        sessionStorage.getItem("user") == "tinashi"
      ) {
        return cellValue;
      } else {
        return utils.plusXing(cellValue, 6, 4);
      }
    },
    computedTime(time) {
      if (time) {
        return moment(time).format("YYYY-MM-DD HH:mm:ss");
      } else {
        return "";
      }
    },
    computedDate(time) {
      if (time) {
        return moment(time).format("YYYY-MM-DD");
      } else {
        return "";
      }
    },
    //工具类，错误提示框
    myNotify(_this, type, normal, or) {
      utils.myNotify(_this, type, normal, or);
    },
    formatNum(row, column, cellValue) {
      if (cellValue) {
        return cellValue;
      } else {
        return "-";
      }
    },
    //提交表单（筛选功能）
    submitForm() {
      this.param2 = JSON.parse(JSON.stringify(this.param));
      this.page.pageNo = 1;
      this.getData();
    },
    //重置表单（清除筛选项）
    resetForm() {
      this.param = {};
      this.param2 = {};
      this.getData();
    },
    //展开收起
    toggleSlide(slideWrap, event) {
      if (this.$refs[slideWrap].offsetHeight === 42) {
        this.$refs[slideWrap].style.height = "auto";
        event.target.innerHTML = "收起筛选项";
      } else {
        this.$refs[slideWrap].style.height = "42px";
        event.target.innerHTML = "展开筛选项";
      }
    },
    // 导出筛选结果
    exportResult() {
      let params = {
        ...this.param,
      };
      this.listLoading = true;
      this.$http({
        method: "POST",
        url: "/rest/salesman/signingRecordExport",
        data: params,
      })
        .then((res) => {
          this.listLoading = false;
          if (res.data && res.data.status == 200) {
            console.log(utils.returnUrlHead() + res.data.data);
            location.href = utils.returnUrlHead() + res.data.data;
          } else {
            this.$alert(res.data.message);
          }
        })
        .catch((error) => {
          this.listLoading = false;
          this.$alert("导出错误，请联系管理员！");
        });
    },
    //翻页
    handleSizeChange(value) {
      this.page.pageSize = value;
      this.getData();
    },
    handleCurrentChange(value) {
      this.page.pageNo = value;
      this.getData();
    },
    getServiceSuppliers() {
      this.$http({
        method: "GET",
        url: "/rest/JiangYiJoint/getServiceSuppliers",
      })
        .then((res) => {
          this.serviceSuppliers = res.data;
        })
        .catch((err) => {
          this.myNotify(this, "error", err.response, "查询失败，请稍后重试");
        });
    },
    //获取客户列表
    getAllClientId() {
      this.$http({
        method: "GET",
        url: "/rest/baseCenter/all-customers",
      })
        .then((res) => {
          this.allClientId = res.data.data;
        })
        .catch((err) => {
          this.myNotify(this, "error", err.response, "查询失败，请稍后重试");
        });
    },
    searchSuppliersAll() {
      this.$http({
        method: "GET",
        url: "/rest/supplier-permute/suppliers-all",
      })
        .then((res) => {
          this.suppliersAll = res.data.data;
        })
        .catch((err) => {
          this.myNotify(this, "error", err.response, "查询失败，请稍后重试");
        });
    },
    /**
       * 查询公司下拉列表
       */
    searchCompaniesAll() {
        this.$http({
          method: 'GET',
          url: '/rest/superviseContract/virtual-project/companies'
        }).then(res => {
          this.companiesAll = res.data.data
        }).catch(err => {
        })
      },
  },
};
</script>
  
  <style scoped>
.cutLine {
  border-right: 1px solid #82bc82;
  margin: 0 10px;
  position: relative;
  right: 1px;
}

.tableBody {
  background-color: white;
  margin-top: 15px;
  padding: 20px;
}

.title {
  color: #2e2b78;
  margin-bottom: 20px;
  font-weight: 900;
}
.slide-wrap {
  height: auto;
}
</style>
<style>
.Qhr_contract .el-dialog__header {
  text-indent: 2em;
}
</style>
  


// WEBPACK FOOTER //
// src/views/personnelCenter/FlexibleSigningRecord.vue